import {
  CopyIcon,
  Mtds,
  ArrowsLeftRightIcon,
  PencilSimpleIcon,
  PlayIcon,
  type PlanStatusEnum,
  StopIcon
} from 'prove-common'

type PlanStatusMenuItemsProps = {
  status: PlanStatusEnum
  onClickDuplicate?: () => void
  onClickMove?: () => void
  onClickActivate?: () => void
  onClickDeactivate?: () => void
  onClickSetAsDraft?: () => void
}

const stop = (fn: (() => void) | undefined) =>
  fn
    ? (e: React.MouseEvent) => {
        e.stopPropagation()
        fn()
      }
    : undefined

export const PlanStatusMenuItems = ({
  status,
  onClickDuplicate,
  onClickMove,
  onClickActivate,
  onClickDeactivate,
  onClickSetAsDraft
}: PlanStatusMenuItemsProps) => (
  <>
    {onClickDuplicate && (
      <li>
        <Mtds.Button type='button' onClick={stop(onClickDuplicate)}>
          <CopyIcon />
          Dupliser
        </Mtds.Button>
      </li>
    )}
    {onClickMove && (
      <li>
        <Mtds.Button type='button' onClick={stop(onClickMove)}>
          <ArrowsLeftRightIcon />
          Flytt underplan
        </Mtds.Button>
      </li>
    )}
    {(onClickActivate || onClickDeactivate) && (
      <li>
        <Mtds.Button
          type='button'
          onClick={
            status === 'active'
              ? stop(onClickDeactivate)
              : stop(onClickActivate)
          }
        >
          {status === 'active' ? <StopIcon /> : <PlayIcon />}
          {status === 'active' ? 'Deaktiver' : 'Aktiver'}
        </Mtds.Button>
      </li>
    )}
    {status !== 'draft' && onClickSetAsDraft && (
      <li>
        <Mtds.Button type='button' onClick={stop(onClickSetAsDraft)}>
          <PencilSimpleIcon />
          Sett som utkast
        </Mtds.Button>
      </li>
    )}
  </>
)
